import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import UserAccount from './indexC'

const mapStateToProps = (state) => {
  return {
    account: state.account,
    userName: state.authState.name,
    emailVerified: state.authState.emailVerified
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    goToUser: () => { dispatch(push('/user'))}
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAccount)



// WEBPACK FOOTER //
// ./src/components/UserAccount/index.js